import { scoreFormat } from "../numberFormatters/scoreFormat"

/**
 * @param {number} score score in number
 * @return {string} score string
 */
export function displayScore(score){
    if(score === 0) return "0"
    const displayedScore = scoreFormat(score)
    if(!displayedScore) return "--"
    return `${displayedScore}`
}